<template>
  <div class="register-page">
    <div class="register-container">
      <div class="register-card">
        <div class="register-brand">
          <div class="brand-icon">
            <svg viewBox="0 0 24 24" width="48" height="48" fill="none" stroke="currentColor" stroke-width="1.5">
              <path d="M23 7l-7 5 7 5V7z" stroke="#ff9600" fill="#ff9600" fill-opacity="0.2"/>
              <rect x="1" y="5" width="15" height="14" rx="2" ry="2" stroke="#ff9600" fill="#ff9600" fill-opacity="0.1"/>
            </svg>
          </div>
          <h1 class="brand-title">灵眸云图</h1>
          <p class="brand-desc">加入我们，开启直播之旅</p>
        </div>
        <div class="register-form">
          <h2 class="form-title">创建账号</h2>
          <p class="form-subtitle">注册后即可享受精彩直播内容</p>
          <div class="form-group">
            <div class="input-wrapper">
              <svg class="input-icon" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="#999" stroke-width="2"><circle cx="12" cy="8" r="4"/><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/></svg>
              <input type="text" v-model="username" placeholder="请输入用户名" @keyup.enter="handleRegister">
            </div>
          </div>
          <div class="form-group">
            <div class="input-wrapper">
              <svg class="input-icon" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="#999" stroke-width="2"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>
              <input type="password" v-model="password" placeholder="请输入密码" @keyup.enter="handleRegister">
            </div>
          </div>
          <div class="form-group">
            <div class="input-wrapper">
              <svg class="input-icon" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="#999" stroke-width="2"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/><line x1="12" y1="16" x2="12" y2="18"/></svg>
              <input type="password" v-model="confirmPassword" placeholder="请确认密码" @keyup.enter="handleRegister">
            </div>
          </div>
          <button class="register-btn" @click="handleRegister" :disabled="loading">
            <span v-if="loading" class="loading-spinner"></span>
            <span>{{ loading ? '注册中...' : '注册' }}</span>
          </button>
          <div class="form-footer">
            <router-link to="/login" class="login-link">已有账号？立即登录</router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { useUserStore } from '../stores/user';
import { register } from '../api/user';

export default {
  name: 'UserRegister',
  setup() {
    const router = useRouter();
    const userStore = useUserStore();
    const username = ref('');
    const password = ref('');
    const confirmPassword = ref('');
    const loading = ref(false);

    const handleRegister = async () => {
      if (!username.value || !password.value || !confirmPassword.value) {
        alert('请填写完整信息');
        return;
      }
      // 用户名校验：3-30 位字母数字下划线
      const uname = username.value.trim();
      if (uname.length < 3 || uname.length > 30) {
        alert('用户名长度需在 3-30 个字符之间');
        return;
      }
      if (!/^[A-Za-z0-9_]+$/.test(uname)) {
        alert('用户名只能包含字母、数字和下划线');
        return;
      }
      // 密码强度校验
      if (password.value.length < 6 || password.value.length > 30) {
        alert('密码长度需在 6-30 个字符之间');
        return;
      }
      if (password.value !== confirmPassword.value) {
        alert('两次输入的密码不一致');
        return;
      }
      loading.value = true;
      try {
        const response = await register(username.value, password.value);
        if (response.data.code === 1) {
          userStore.setUserInfo(response.data.data.userinfo);
          router.push('/');
        } else {
          alert(response.data.msg || '注册失败');
        }
      } catch (error) {
        console.error('注册失败:', error);
        alert('注册失败，请稍后重试');
      } finally {
        loading.value = false;
      }
    };

    return { username, password, confirmPassword, loading, handleRegister };
  }
};
</script>

<style scoped>
.register-page {
  min-height: 100vh;
  display: flex;
  background: linear-gradient(135deg, #0f0f1a 0%, #1a1a2e 50%, #16213e 100%);
  position: relative;
  overflow: hidden;
}

.register-page::before {
  content: '';
  position: absolute;
  top: -40%;
  left: -20%;
  width: 500px;
  height: 500px;
  background: radial-gradient(circle, rgba(255,150,0,0.08) 0%, transparent 70%);
  border-radius: 50%;
  pointer-events: none;
}

.register-page::after {
  content: '';
  position: absolute;
  bottom: -30%;
  right: -20%;
  width: 600px;
  height: 600px;
  background: radial-gradient(circle, rgba(255,106,0,0.06) 0%, transparent 70%);
  border-radius: 50%;
  pointer-events: none;
}

.register-container {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 1;
}

.register-card {
  display: flex;
  background: rgba(255,255,255,0.95);
  backdrop-filter: blur(20px);
  border-radius: 24px;
  box-shadow: 0 24px 80px rgba(0,0,0,0.3);
  overflow: hidden;
  width: 800px;
  max-width: 92vw;
  min-height: 520px;
}

.register-brand {
  width: 320px;
  background: linear-gradient(135deg, #ff6a00, #ff9600, #ffaa33);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px;
  color: #fff;
  position: relative;
  overflow: hidden;
}

.register-brand::before {
  content: '';
  position: absolute;
  top: -100px;
  right: -100px;
  width: 300px;
  height: 300px;
  background: rgba(255,255,255,0.08);
  border-radius: 50%;
}

.register-brand::after {
  content: '';
  position: absolute;
  bottom: -60px;
  left: -60px;
  width: 200px;
  height: 200px;
  background: rgba(255,255,255,0.06);
  border-radius: 50%;
}

.brand-icon {
  margin-bottom: 20px;
  position: relative;
  z-index: 1;
}

.brand-title {
  font-size: 32px;
  font-weight: 800;
  margin: 0 0 8px;
  letter-spacing: 2px;
  position: relative;
  z-index: 1;
}

.brand-desc {
  font-size: 15px;
  opacity: 0.85;
  position: relative;
  z-index: 1;
  margin: 0;
}

.register-form {
  flex: 1;
  padding: 48px 44px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.form-title {
  font-size: 26px;
  color: #1a1a2e;
  font-weight: 700;
  margin: 0 0 6px;
}

.form-subtitle {
  font-size: 14px;
  color: #94a3b8;
  margin: 0 0 32px;
}

.form-group {
  margin-bottom: 18px;
}

.input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.input-icon {
  position: absolute;
  left: 14px;
  pointer-events: none;
  flex-shrink: 0;
}

.input-wrapper input {
  width: 100%;
  padding: 14px 14px 14px 44px;
  border: 1.5px solid #e2e8f0;
  border-radius: 12px;
  font-size: 15px;
  color: #1e293b;
  background: #f8fafc;
  outline: none;
  transition: all 0.3s ease;
  box-sizing: border-box;
}

.input-wrapper input:focus {
  border-color: #ff9600;
  background: #fff;
  box-shadow: 0 0 0 4px rgba(255,150,0,0.1);
}

.input-wrapper input::placeholder {
  color: #94a3b8;
}

.register-btn {
  width: 100%;
  padding: 14px;
  background: linear-gradient(135deg, #ff6a00, #ff9600);
  color: #fff;
  border: none;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 8px;
  box-shadow: 0 4px 16px rgba(255,106,0,0.3);
}

.register-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(255,106,0,0.4);
}

.register-btn:active:not(:disabled) {
  transform: translateY(0);
}

.register-btn:disabled {
  background: #e2e8f0;
  box-shadow: none;
  cursor: not-allowed;
}

.loading-spinner {
  width: 20px;
  height: 20px;
  border: 2px solid rgba(255,255,255,0.3);
  border-top-color: #fff;
  border-radius: 50%;
  animation: spin 0.6s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

.form-footer {
  text-align: center;
  margin-top: 24px;
}

.login-link {
  color: #ff9600;
  text-decoration: none;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s;
}

.login-link:hover {
  color: #ff6a00;
  text-decoration: underline;
}

@media (max-width: 768px) {
  .register-card {
    flex-direction: column;
    min-height: auto;
  }
  .register-brand {
    width: 100%;
    padding: 32px;
    min-height: 160px;
  }
  .register-form {
    padding: 32px 28px;
  }
  .brand-title {
    font-size: 26px;
  }
}
</style>